import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../common/state';
import { openAdvancedModal } from '../../state/advanced/toggle_modal';
import { makeSearch } from '../../state/search';
import {
  dealTypeFromJsonQuery,
  offerTypeFromJsonQuery,
  isUrban,
  FDealType,
  isSuburban,
  FOfferType,
} from '../../../utils/category';
import { isFiltersDropdownExperimentActive } from '../../../experiments/filtersDropdown';
import { isFiltersDropdownSuburbanExperimentActive } from '../../../experiments/filtersDropdownSuburban';
import { setFiltersPosition } from '../../../serp/state/coworking_experiments/coworkingPopup';

import { trackAdvancedModalOpenEvent } from './tracking';
import { EPosition, Filters as FiltersComponent } from './filters';
import { filtersScrolledDown, filtersScrolledUp } from '../../../serp/state/coworking_experiments/coworkingHelper';

export const mapStateToProps = (state: IAppState) => {
  const { jsonQuery } = state.filters;

  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  return {
    isNewAdvancedFilters:
      (dealType === FDealType.Sale && (offerType & (FOfferType.Urban & ~FOfferType.FlatNew)) !== 0) ||
      ((dealType & FDealType.Rent) !== 0 &&
        isUrban(offerType) &&
        isFiltersDropdownExperimentActive(state.experiments)) ||
      (isSuburban(offerType) && isFiltersDropdownSuburbanExperimentActive(state.experiments)),
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAdvancedModalOpen: () => {
    dispatch(openAdvancedModal());

    trackAdvancedModalOpenEvent();
  },
  onSearchButtonClick: () => {
    dispatch(makeSearch());
  },
  onFiltersScrollUp: () => {
    dispatch(filtersScrolledUp());
  },
  onFiltersScrollDown: () => {
    dispatch(filtersScrolledDown());
  },
  setFiltersPosition: (position: EPosition) => {
    dispatch(setFiltersPosition(position));
  },
});

export const Filters = connect(mapStateToProps, mapDispatchToProps)(FiltersComponent);
